import { useEffect } from 'react'
import { IAgentActivityReport, IUserTask } from '@obvious.tech/constellation'

import api, { TApiError, TApiResponse, TEntity } from 'src/utils/api'
import { TLoadable } from 'src/utils/Loadable'

export type TParsedGuardTours = Array<TEntity<IUserTask>>

export type TUseGuardToursResults = TLoadable<TParsedGuardTours, TApiError>

export type TProps = {
  entity: TEntity<IAgentActivityReport>
  authorization?: string
}

const getGuardToursByID = async ({
  id,
  token,
}: {
  id: string
  token?: string
}): Promise<TApiResponse<Array<TEntity<IUserTask>>, TApiError>> =>
  await api.getResourcesWithFilters<TEntity<IUserTask>>('tasks/api/UserTask')({
    filters: [
      ['taskGrouping.entityId', api.Filter.Eq, id],
      ['taskGrouping.type', api.Filter.Eq, 'AgentActivityReport'],
    ],
    sorts: '-createdAt',
    token,
  })

const useGuardTours = ({
  entity,
  authorization,
}: TProps): TUseGuardToursResults => {
  const [guardTours, getGuardTours] = api.useApiAction(getGuardToursByID)

  useEffect(() => {
    return getGuardTours({
      id: entity.id,
      token: authorization,
    })
  }, [entity, authorization, getGuardTours])

  return guardTours
}

export default useGuardTours
